import { RouteName } from '@src/app/router/constants/RouteName';
import { Route } from 'vue-router';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { ModalEntry } from '@superbet-group/web.lib.vue-utilities';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';

/**
 * On ResponsibleGaming page we don't want to show following modals
 */
const excludeModals = [modalCodes.welcomeOffer, 'ftpEligibleInfo'];

/**
 * Function that checks if certain modals should be shown on current route.
 */
export function isModalShownOnCurrentRoute(route: Route, modal: ModalEntry) {
    if (noModalsRoutes.has(route.name!) && !alwaysShownModals.has(modal.code)) {
        return false;
    }

    // Don't show specific modals on RG routes
    return !responsibleGamingRoutes.has(route.name!)
    || shellLocalConfig.shouldShowModalsOnResponsibleGamingPage
    || !excludeModals.includes(modal.code);
}

const responsibleGamingRoutes = new Set([
    RouteName.Account.ResponsibleGaming,
    RouteName.Account.DepositLimit,
    RouteName.Account.BettingLimit,
    RouteName.Account.LossLimit,
    RouteName.Account.SessionLimit,
    RouteName.Account.SelfExclusion,
    RouteName.Account.AccountClosure,
    RouteName.Account.TimeOut,
    RouteName.Account.RealityCheck,
]);

export const noModalsRoutes = new Set<string>([
    RouteName.App.Wiki,
]);

const alwaysShownModals = new Set<string>([
    modalCodes.error,
    modalCodes.sessionDuration,
    modalCodes.login,
    modalCodes.realityCheck,
    modalCodes.logoutDelay,
    modalCodes.lastLogin,
    modalCodes.geoLocationCheck,
]);
